import { create } from "zustand";
import { loadOnboardingConfiguration } from "./api";

// The existing system flag is backend-only. Read its public boolean through the
// onboarding boundary, once per loaded journey; no Firestore grants or polling.
export const useOnboardingConfiguration = create<{
  enabled: boolean | null;
  status: "idle" | "loading" | "ready" | "error";
  load: () => Promise<void>;
}>((set, get) => ({
  enabled: null,
  status: "idle",
  load: async () => {
    if (get().status === "loading" || get().enabled !== null) return;
    set({ status: "loading" });
    try {
      set({ enabled: await loadOnboardingConfiguration(), status: "ready" });
    } catch {
      set({ enabled: null, status: "error" });
    }
  },
}));
